<template>
  <p :class="classes">
    <span class="cordel-toast-content">
      <slot>
        Olá, mundo!
      </slot>
    </span>

    <button
      class="cordel-toast-button"
      @click="close"
    >
      <font-awesome-icon
        class="cordel-toast-icon"
        icon="times"
      />
    </button>
  </p>
</template>

<script>
  const COLORS = ['warning'];

  export default {
    name: 'CordelContextToast',
    props: {
      color: {
        type: String,
        default: COLORS[0],
        validator(value) {
          return COLORS.includes(value);
        },
      },
    },
    computed: {
      classes() {
        const classes = [
          'cordel-toast',
          `color--${this.color}`,
        ];

        return classes;
      },
    },
    methods: {
      close() {
        this.$emit('close');
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .cordel-toast {
    align-items: stretch;
    background-color: var(--cordel-color-tag-warning);
    border-radius: var(--cordel-border-radius-small);
    color: var(--cordel-color-constant-dark);
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;

    @media all and (max-width: $cordel-breakpoint-mobile) {
      font-size: var(--cordel-font-size-s);
    }
  }

  .cordel-toast-content {
    flex: 1;
    padding: var(--cordel-spacing-xxs);

    @media all and (max-width: $cordel-breakpoint-mobile) {
      font-size: var(--cordel-font-size-s);
    }
  }

  .cordel-toast-button {
    @include cordel-input-reset;

    color: inherit;
    cursor: pointer;
    font-size: calc(var(--cordel-font-size-m) * var(--cordel-line-height-s));
    line-height: 1;
    padding: 0 var(--cordel-spacing-xxs) 0 var(--cordel-spacing-xxxs);

    @media all and (max-width: $cordel-breakpoint-mobile) {
      font-size: calc(var(--cordel-font-size-s) * var(--cordel-line-height-s));
    }
  }
</style>
